import { render, staticRenderFns } from "./gopay.vue?vue&type=template&id=732a9e08&scoped=true&"
import script from "./gopay.vue?vue&type=script&lang=js&"
export * from "./gopay.vue?vue&type=script&lang=js&"
import style0 from "./gopay.vue?vue&type=style&index=0&id=732a9e08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732a9e08",
  null
  
)

export default component.exports